import React from 'react';
import P from '@hero/ui-kit/typography/P';
import useTheme from '@hero/branding/theme';
import { MarkSelect, MarkLabel } from '../../../components/MarkControls';
import type { SegmentFilterOperator } from '../../../types';
import * as styles from './style.module.css';

type Props = {
    value: SegmentFilterOperator;
    operators: SegmentFilterOperator[];
    onChange: (operator: SegmentFilterOperator) => void;
    id: string;
};
export const OPERATOR_LABELS: Record<SegmentFilterOperator, string> = {
    in: 'is one of',
    not_in: 'is not one of',
    between: 'is between',
    after: 'is after',
    before: 'is before',
    is_null: 'is empty / not empty',
    contains: 'contains'
};
const OperatorSelect: React.FC<Props> = ({ value, operators, onChange, id }) => {
    const { colors } = useTheme();
    return (
        <div className={styles.field}>
            <MarkLabel htmlFor={id} style={{ margin: 0 }}>
                Condition
            </MarkLabel>
            <MarkSelect
                id={id}
                value={operators.length ? value : ''}
                onChange={(event) => onChange(event.currentTarget.value as SegmentFilterOperator)}
                disabled={!operators.length}
                style={{ width: '100%' }}
            >
                {!operators.length && <option value="">Choose a field first</option>}
                {operators.map((operator) => (
                    <option key={operator} value={operator}>
                        {OPERATOR_LABELS[operator]}
                    </option>
                ))}
            </MarkSelect>
            {value === 'not_in' && (
                <P noDefaultMargin size="small" styles={{ color: colors.neutrals.textBeta }}>
                    Also includes records where this field is empty.
                </P>
            )}
        </div>
    );
};
export default OperatorSelect;
